<template>
    
  <div  class="message">
    <div class="row" style="height:100%">
      
      <div v-show="false" class="col-sm-12">
        <h2>Nachricht</h2>
      </div>

      <div :class="{ 'col-sm-10': showButtons, 'col-sm-12': !(showButtons) }" style="height:100%">
        <!-- <p>{{query}}</p> -->
        <div class="message-wraper">
          <select 
            style="width:50%"
            v-if="showOptionsMsgKeywords" 
            class="form-control text-left" 
            :class="{ 'cc-required': requiredOptionsMsgKeywords }" 
            @input="onUpdateStatus"
            v-model="messageStatus"
          >
            <option v-for="option in optionsMsgKeywords"
              :value="option"
              v-text="option">
            </option>
          </select>

      <div class="message-wraper" style="position: relative">
        <textarea required
            class="form-control"
            id="idmessage"
            rows="7" 
            placeholder="Nachricht eingeben..."  
            v-model="message"   
            @input="onUpdate">
          </textarea>
        
        <button v-show="message" type="button"
            style="position: absolute; bottom:10px; right:10px; border: 0 none;"
            class="btn btn-default" 
            @click="onClickClearMessage"
            title="Nachricht löschen">
            <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
        </button>
        </div>
        </div>
      </div>
      
      <div v-show="showButtons" class="col-sm-2 text-center cc-call-buttons" style="height:100%" >
        
        <button type="button" 
          class="btn btn-success btn-block" 
          @click="onHitCompletion" 
          title="Anruf abschließen">
          <i class="fa fa-send fa-lg " aria-hidden="true"></i>
        </button>
        
        <button type="button" 
          :disabled="!showTrashButton" 
          class="btn btn-warning btn-block" 
          @click="onHitTrash" 
          title="Papierkorb">
          <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
        </button>
        
        <button type="button"
          :disabled="!showParkingButton" 
          class="btn btn-primary btn-block" 
          @click="onHitParking" 
          title="Parken">
          <i class="fa fa-thumb-tack fa-lg" aria-hidden="true"></i>
        </button>
        
        <button type="button"
          style="position: absolute; bottom:-15px; right:15px; width: calc(100% - 30px);"
          class="btn  btn-danger btn-block" 
          @click="onHitCancel"
          title="Abbruch">
          <i class="fa fa-times-circle fa-lg" aria-hidden="true"></i>
        </button>
        
      </div>    
    </div>
                 
    <cc-message-modal
      v-if="showModal"
      @send="showModal = false"
      @close="showModal = false"
      >

      <div slot="header">
        
        <h3 v-show="exitState == 'completion'">
          <button type="button" 
            class="btn btn-success btn-lg" 
            title="Anruf abschließen">
            <i class="fa fa-send fa-lg" aria-hidden="true"></i>
          </button>
          Call Abschließen
        </h3>

        <h3 v-show="exitState == 'trash'">
          <button type="button" 
            class="btn btn-warning btn-lg" 
            title="Papierkorb">
            <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
          </button>
          Call in Papierkorb
        </h3>

        <h3 v-show="exitState == 'parking'">
          <button type="button"
            class="btn btn-primary btn-lg" 
            title="Parken">
            <i class="fa fa-thumb-tack fa-lg" aria-hidden="true"></i>
          </button>
          Call wird geparkt
        </h3>

        <h3 v-show="exitState == 'abort'">
          <button type="button"
            class="btn  btn-danger btn-lg" 
            title="Abbruch">
            <i class="fa fa-times-circle fa-lg" aria-hidden="true"></i>
          </button>
          Call wird abgebrochen!
        </h3>
        
      </div>
      
      <div slot="body">
         
        <div v-if="showModalSpinner" style="padding-top: 50px;" class="text-center">
          <i class="fa fa-refresh fa-spin fa-5x fa-fw"></i>
        </div>
        
        <div class="alert cc-attention " v-for="msg in errorMsg">
          <span class="glyphicon glyphicon-warning-sign" aria-hidden="true"></span>
          <span  v-html=msg></span>
        </div>

        <div class="alert cc-attention" v-for="msg in warningMsg">
         <span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span>
          <strong></strong>{{msg}}
        </div>
       
      </div>
      
      <div slot="footer">
        <div v-show="!showSendCallButton" class="alert alert-danger text-left">
          <span>Anruf kann nicht abgeschlossen werden!</span>
        </div>
        <button v-show="showWarningButton" type="" class="btn btn-warning"  @click="sendCall(exitState)">Trotz Warnung abschließen!</button>
        <button type="" class="btn btn-primary"  @click="showModal = false">Schließen</button>
      
      </div>

    </cc-message-modal>
             
                  
  </div>           
                   
    
</template>



<script>

import bus from './common/bus'
import MessageModal from './MessageModal.vue'
import { END_MODAL_TIMER } from './common/misc.conf.js'

export default {
    
  components: {
    'cc-message-modal': MessageModal,
  },
  
  data () {
    return {
      optionsMsgKeywords: [''],
      showModal: false,
      showModalSpinner: false,
      exitState: 'abort',
      errorMsg: [],
      warningMsg: [],
      message: '',
      messageStatus: '',
      query: '',
      showButtons: false,
      showTrashButton: false,
    }
  },
  
  created: function () {
    //bus.registerOnLogin(this.reset);
    bus.registerOnCompanyClient(this.onCompanyClient);
    bus.registerOnResetCompanyClient(this.onResetCompanyClient);
    
    bus.registerOnIdUserClient(this.onIdUserClient);
    bus.registerOnAddMessage(this.onAddMessage);
    bus.registerOnMessageStatus(this.onMessageStatus);

  },
  
  computed: {
    
  
    showParkingButton: function () {
      return !!(bus.login.companyCallCenter.advancedFeatures.search("parken") != -1)
    },

    showSendCallButton: function () {
      return !!(this.errorMsg.length == 0)
    },

    showWarningButton: function () {
      return !!(this.warningMsg.length != 0 && (this.errorMsg.length == 0))
    },

    
    showOptionsMsgKeywords: function () {
      return !(this.optionsMsgKeywords.length == 1 && this.optionsMsgKeywords[0] == false);
    },
    
    requiredOptionsMsgKeywords: function () {
      return  !!(this.optionsMsgKeywords.length > 1 && _.trim(this.optionsMsgKeywords[0] == false) && this.messageStatus == false);
    },
  },
  
  methods: {
    
    onUpdateStatus: function () {
      //emitMessageSearch();
      $('.message').find('select').css("background-color","#fff");

    },
    
    onUpdate: function () {
      //emitMessageSearch();
      $('.message').find('textarea').css("background-color","#fff");
      
      this.message =  this.message.replace(/#aufleger/gi, 'Die Aufnahme einer Gesprächsnotiz war bei diesem Anruf leider nicht möglich, da die Leitung während der Gesprächsannahme unterbrochen wurde.\n')
      this.message =  this.message.replace(/#sendetmail/gi, 'Sendet ihnen zum Sachverhalt eine E-Mail.\n')
      this.message =  this.message.replace(/#keineangabe/gi, 'Möchte keine weiteren Angaben über konkretes Anliegen mitteilen.\n')
      this.message =  this.message.replace(/#reaktionszeit/gi, 'Wurde auf die voraussichtliche Reaktionszeit hingewiesen.\n')
      this.message =  this.message.replace(/#abwesenheit/gi, 'Wurde über den Abwesenheitsgrund informiert.\n')
      this.message =  this.message.replace(/#faq/gi, 'Es wurden Auskünfte gemäß den hinterlegten FAQ erteilt.\n')
      this.message =  this.message.replace(/#info/gi, 'Es wurden Auskünfte gemäß den hinterlegten Informationen erteilt.\n')
      this.message =  this.message.replace(/#werbeanruf/gi, 'Bei diesem Anruf handelte es sich um einen Werbeanruf. Diese Nachricht erfolgt nur zur Kenntnisnahme.\n')
      this.message =  this.message.replace(/#andere/gi, 'Ruft im Namen von Herrn / Frau an.\n')
      this.message =  this.message.replace(/#dw/gi, 'Es wurde die Durchwahl mitgeteilt.\n')
      this.message =  this.message.replace(/#mail/gi, 'Es wurde die E-Mail-Adresse mitgeteilt.\n')
      this.message =  this.message.replace(/#keinrr/gi, 'Wünscht keinen Rückruf und möchte keine Kontaktdaten hinterlassen.\n')
      this.message =  this.message.replace(/#rr/gi, 'Reagiert auf einen vorherigen Anrufversuch von Ihnen.\n')
      
      let lines  = this.message.trim().split('\n');
      let q = '';
      lines.forEach(function(l, index, array) {
        if(l.search('>') != -1){
          q += l.replace(/>/g, '') + ' ';
        }  
      });
      q = q.trim(); // letztes blank löschen
      if(this.query != q){
        this.query = q;
        bus.emitMessageSearch(q);
      }

      
    },

    onClickClearMessage: function () {
      this.message = '';
      $( '#idmessage' ).focus();
    },
  
    onAddMessage: function (message, event, call) {
     this.message = this.message + message;
    },

    onMessageStatus: function (messageStatus, event, call) {
     this.messageStatus = messageStatus;
    },

    onCompanyClient: function (companyClient, event, call) {
      //this.reset();
      this.showTrashButton = !!(companyClient.featurePapierkorb == '1');
      this.showButtons = true;
      
      
      this.optionsMsgKeywords = _.trim(companyClient.templateMsgKeywords).split(';');
      
      // Der messageStatus könnte schon von onMessageStatus wg Parken gesetzt sein
      if(this.messageStatus == '' ){
        this.messageStatus = this.optionsMsgKeywords[0];
      }
      
    },

    onResetCompanyClient: function () {
      //this.reset();
      this.messageStatus = '';
      this.optionsMsgKeywords = [''];
      this.showTrashButton = false;
      this.showButtons = false;
    },

    onIdUserClient: function(idUserClient, event, call){
      // focus nur setzten wenn ein anrufer bereits ausgewählt
      if(idUserClient > 0 && call.idUserCaller > 0) {
        this.$nextTick(function () {
          $( "#idmessage" ).focus(); 
        });
      }
    },
    
    
    sendCall: function(exitState){
       
       bus.call.message = this.message;
       bus.call.messageStatus = this.messageStatus;
  
       this.exitState = exitState;
       this.showModalSpinner = true;
       this.showModal = true;
       bus.callEnd(exitState, this.cbSendCallOk, this.cbSendCallErr);
    },

    cbSendCallOk: function() {
      // wait with reset a little bit with spinner
      setTimeout(this.reset, END_MODAL_TIMER );
    },

    cbSendCallErr: function(errMsg) {
        this.errorMsg.push("Es ist Unerwarteter Fehler beim Call abschluss aufgetreten! <br><pre>" + JSON.stringify(errMsg, null, 2) + "</pre>");
        this.showModal = true;
        this.showModalSpinner = false;
    },
    
    
    onHitCompletion: function() {
      let call = bus.getCall();
      let shipping = bus.getIdsShipping();
      
      this.exitState = 'completion';
      this.errorMsg = [];
      this.warningMsg = [];
      
      let size;
      if((size = $('.cc-user-kombox-form').find(':submit').size())){
          $('.cc-user-kombox-form').find('select, input').css("background-color","#f9f7c0");
          $('.cc-user-kombox-form').find('input')[0].focus();
        if(size == 1 ){
          this.errorMsg.push("Es ist noch ein Anruferkontakt in Bearbeitung!");
        }else{
          this.errorMsg.push("Es sind noch Anruferkontakte in Bearbeitung!");
        }
        this.showModal = true;
      }
      
      
      if(call.idUserCaller == 0){
        if($('.user-caller-form').size()){
          this.errorMsg.push("Der Anrufer ist noch in Bearbeitung!");
          $('.user-caller-form').css("background-color","#f9f7c0");
          $(".cc-attention" ).addClass( "btn-danger" ).removeClass( "cc-attention" );
        }else{
          this.errorMsg.push("Kein Anrufer ausgewählt!");
          $('.user-caller-typeahead').find('input').css("background-color","#f9f7c0");
        }
        this.showModal = true;
      }else{
        if(call.idsKomboxUserCaller.length == 0){
          this.warningMsg.push("Kein Kontakt vom Anrufer hinterlegt!");
          this.showModal = true;
        }
      }

      if(this.message.length == 0){
        this.errorMsg.push("Keine Nachricht hinterlassen!");
        $('.message').find('textarea').css("background-color","#f9f7c0");
        this.showModal = true;
      }

      if(this.requiredOptionsMsgKeywords){
        this.errorMsg.push("Keine Nachricht Status ausgewählt");
        $('.message').find('select').css("background-color","#f9f7c0");
        this.showModal = true;
      }

      if(shipping.length == 0){
        this.warningMsg.push("Kein Vesand ausgewählt!");
        $('.cc-kombox-list').find('.btn-default').css("background-color","#f9f7c0");
        this.showModal = true;
      }
      

      if(this.errorMsg.length == 0 && this.warningMsg == 0){
        this.sendCall('completion');
      }
      
      //console.log(JSON.stringify(this.errorMsg, null, 2));
    },
    
    

    onHitTrash: function() {
      let call = bus.getCall();
      let shipping = bus.getIdsShipping();
      
      
      this.exitState = 'trash';
      this.errorMsg = [];
      this.warningMsg = [];
      
      // ERROR: Caller Contact in processing
      let size;
      if((size = $('.cc-user-kombox-form').find(':submit').size())){
          $('.cc-user-kombox-form').find('select, input').css("background-color","#f9f7c0");
          $('.cc-user-kombox-form').find('input')[0].focus();
        if(size == 1 ){
          this.errorMsg.push("Es ist noch ein Anruferkontakt in Bearbeitung!");
        }else{
          this.errorMsg.push("Es sind noch Anruferkontakte in Bearbeitung!");
        }
        this.showModal = true;
      }
      
      
      // ERROR: Caller in processing
      if(call.idUserCaller == 0){
        if($('.user-caller-form').size()){
          this.errorMsg.push("Der Anrufer ist noch in Bearbeitung!");
          $('.user-caller-form').css("background-color","#f9f7c0");
          $(".cc-attention" ).addClass( "btn-danger" ).removeClass( "cc-attention" );
        }else{
          this.errorMsg.push("Kein Anrufer ausgewählt!");
          $('.user-caller-typeahead').find('input').css("background-color","#f9f7c0");
        }
        this.showModal = true;
      }

      // Warning: if Massagebox empty
      if(this.message.length == 0){
        this.warningMsg.push("Keine Nachricht hinterlassen!");
        $('.message').find('textarea').css("background-color","#f9f7c0");
        this.showModal = true;
      }


      if(this.errorMsg.length == 0 && this.warningMsg == 0){
        this.sendCall('trash');
      }
    },
    
    

    onHitParking: function() {
      this.sendCall('parking');
    },

    onHitCancel: function() {
      this.sendCall('abort');
    },


    
    reset: function () {
      this.optionsMsgKeywords = [''];
      this.message = "";
      this.messageStatus = "";
      this.query = "";
      this.exitState = "abort",
      this.errorMsg = [];
      this.warningMsg= [];
      this.showModal = false;
      this.showModalSpinner = false;
      this.showButtons = false;
      this.showTrashButton = false;
      $('.message').find('textarea').css("background-color","#fff");

    },
    
  }
}
</script>



<style scoped>
  
  #idmessage{
    height:100%;
  }
  
  .message-wraper{
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: column;
    flex-direction: column;
    height: calc(100%);
  }
  
  .cc-required {
    border: 1px solid red;
  }
  
  
  .cc-call-buttons button{
    margin-bottom: 15px;
    height: 40px;
  }
  
  .message{
    height: 100%;
  }
  .alert-danger{
    font-size: 24px;
  }

  .cc-attention{
      background-color: #f9f7c0;
      font-size: 20px;
  }  
  .cc-attention .glyphicon{
    padding: 0px 15px 0px 10px;
    font-size: 24px;
    color: darkgray;
  }
  
</style>



// WEBPACK FOOTER //
// Message.vue?19abc73d